<template>
  <div class="impact-value">
    <div class="impact-value__bars">
      <div v-for="bar in distribution" :key="bar.label" class="impact-value__bar">
        <span class="impact-value__label">{{ bar.label }}</span>
        <span
          class="impact-value__bar-label"
          :class="{ 'impact-value__bar-label-positive': parseFloat(bar.value) * bar.order > 0 }"
        >
          {{ getPlusMinusForValue(bar.value) }}
        </span>
        <div class="impact-value__bar_inner" :style="{ width: bar.globalValue * 100 + '%' }" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImpactDistribution',

  props: {
    distribution: {
      type: Array,
      default: null,
    },
  },

  methods: {
    getPlusMinusForValue(value) {
      let char;
      if (value < 0) {
        char = value < -0.1 ? '−−' : '−';
      } else {
        char = value > 0.1 ? '++' : '+';
      }
      return char;
    },
  },
};
</script>

<style lang="scss">
.impact-value {
  position: relative;
  width: 100%;
  margin-top: 10px;
  text-align: left;

  h2 {
    font-size: inherit;
    margin-bottom: 10px;
  }

  h3 {
    font-size: inherit;
    margin-bottom: 20px;
    display: block;
    padding-right: 10px;
  }

  p {
    line-height: 25px;
  }
}

.impact-value__bars {
  position: relative;
}

.impact-value__bar {
  position: relative;
  padding-right: 40px;

  & + & {
    margin-top: 20px;
  }
}

$bar-height: 10px;
.impact-value__bar_inner {
  position: relative;
  @include linear-gradient($color-purple, $color-blue, 45deg);
  height: $bar-height;
  border-radius: 10px;
  margin-top: 10px;
}

.impact-value__bar-label {
  position: absolute;
  right: -20px;
  top: 0;
  width: 30px;
  text-align: center;
  font-size: 15px;
  height: 100%;
  color: $color-purple;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.impact-value__bar-label-positive {
  color: $color-green;
}

.impact-value__label {
  position: relative;
  font-size: 12px;
}

@include helper__greater($bp-1024) {
  .impact-value__label {
    font-size: 14px;
  }
}
</style>
